export type Locale = 'zh-CN' | 'en';

export type Product = {
  id: string;
  category: 'core' | 'advanced' | 'institutional';
  name: string;
  description: string;
  href: string;
  count: number;
  protocols: Array<{kind: 'REST' | 'Streams'; label: string; href: string}>;
};

export function getProducts(locale: Locale): Product[] {
  const zh = locale === 'zh-CN';
  const prefix = zh ? '/zh-CN' : '';

  return [
    {
      id: 'spot', category: 'core', name: zh ? '现货交易' : 'Spot Trading',
      description: zh ? '访问市场数据、管理账户，并在 WEEX 现货市场进行交易。' : 'Access market data, manage accounts, and trade on WEEX Spot.',
      href: `${prefix}/catalog/core-trading-spot/api/rest-api/configapi`, count: 29,
      protocols: [
        {kind: 'REST', label: 'REST', href: `${prefix}/catalog/core-trading-spot/api/rest-api/configapi`},
        {kind: 'Streams', label: zh ? 'WebSocket 数据流' : 'WebSocket Streams', href: `${prefix}/catalog/core-trading-spot/api/ws-streams/public`},
      ],
    },
    {
      id: 'futures', category: 'core', name: zh ? '合约交易' : 'Futures Trading',
      description: zh ? '访问行情、账户和仓位数据，并交易 WEEX 永续合约。' : 'Access market, account, and position data and trade WEEX perpetual futures.',
      href: `${prefix}/catalog/core-trading-futures/api/rest-api/market-api`, count: 46,
      protocols: [
        {kind: 'REST', label: 'REST', href: `${prefix}/catalog/core-trading-futures/api/rest-api/market-api`},
        {kind: 'Streams', label: zh ? 'WebSocket 数据流' : 'WebSocket Streams', href: `${prefix}/catalog/core-trading-futures/api/ws-streams/public`},
      ],
    },
    {
      id: 'wallet', category: 'core', name: zh ? '钱包' : 'Wallet',
      description: zh ? '管理账户间资产划转、充币地址、充币记录及链上提币。' : 'Manage account transfers, deposit addresses and history, and on-chain withdrawals.',
      href: `${prefix}/products/wallet/Introduction`, count: 8,
      protocols: [{kind: 'REST', label: 'REST', href: `${prefix}/catalog/wallet/api/rest-api/assets`}],
    },
    {
      id: 'copy', category: 'advanced', name: zh ? '跟单交易' : 'Copy Trading',
      description: zh ? '查询带单交易与跟单订单，管理跟单配置和仓位。' : 'Query lead trader and follower orders, and manage copy trading settings and positions.',
      href: `${prefix}/catalog/advanced-trading-copy-trading/api/rest-api/trader`, count: 10,
      protocols: [{kind: 'REST', label: 'REST', href: `${prefix}/catalog/advanced-trading-copy-trading/api/rest-api/trader`}],
    },
    {
      id: 'broker', category: 'institutional', name: zh ? '经纪商' : 'Broker',
      description: zh ? '面向经纪商的用户管理、返佣结算与子账户管理接口。' : 'User management, rebate settlement, and sub-account APIs for brokers.',
      href: `${prefix}/catalog/vip-institutional-broker/api/rest-api/api`, count: 11,
      protocols: [{kind: 'REST', label: 'REST', href: `${prefix}/catalog/vip-institutional-broker/api/rest-api/api`}],
    },
    {
      id: 'partner', category: 'institutional', name: zh ? '合伙人' : 'Partner',
      description: zh ? '查询返佣数据、管理邀请用户并跟踪合作伙伴业务表现。' : 'Query rebates, manage invited users, and track partner performance.',
      href: `${prefix}/catalog/vip-institutional-partner/api/rest-api/rebate-endpoints`, count: 13,
      protocols: [{kind: 'REST', label: 'REST', href: `${prefix}/catalog/vip-institutional-partner/api/rest-api/rebate-endpoints`}],
    },
  ];
}
